import { colorByGender } from './common';
import { Label, Popup } from './';
import React from 'react';

const ContestLabel = ({ contest }) => (
  <Popup
    trigger={
      <Label color={colorByGender(contest.ageGroup.gender)}>
        {contest.bodyweightCategory.abbreviation}
        <Label.Detail>{contest.ageGroup.abbreviation}</Label.Detail>
      </Label>
    }
  >
    {contest.ageGroup.title} {contest.bodyweightCategory.title}
  </Popup>
);

export default ContestLabel;



// WEBPACK FOOTER //
// ./src/components/ContestLabel.js